import { MultiCheckboxSelect } from "@/components/ui/multi-checkbox-select";
import { trpc } from "@/hooks/trpc";

/**
 * Scale-applicability picker shared by the operation-attribute inspector and the
 * tabular-column inspector. Owns the `scalesList` query (TanStack Query dedupes
 * it across instances) so the two stay in sync. Empty selection = every scale.
 */
export function AppliesToScalesField({
  value,
  onChange,
  disabled,
  className,
}: {
  value: number[] | null | undefined;
  onChange: (ids: number[] | null) => void;
  disabled?: boolean;
  className?: string;
}) {
  const { data: scales } = trpc.harvest.scalesList.useQuery();

  return (
    <>
      <MultiCheckboxSelect
        options={(scales ?? []).map((s) => ({
          label: s.label,
          value: String(s.id),
        }))}
        value={(value ?? []).map(String)}
        onChange={(ids: string[]) =>
          onChange(ids.length === 0 ? null : ids.map((v) => Number(v)))
        }
        placeholder="Every scale"
        disabled={disabled}
        className={className}
      />
      <p className="text-xs text-olive-11 mt-1">
        Only collected at the selected scales. Leave empty for every scale.
      </p>
    </>
  );
}
